import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CanDoForm from './CanDoForm';
import CanDosFormService from '../../services/CanDosFormService';

class CanDoFormContainer extends Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    courseId: PropTypes.string.isRequired,
    itemId: PropTypes.string,
  };

  static defaultProps = {
    itemId: null,
  };

  canDoFormService = new CanDosFormService();
  componentWillMount() {
    this.canDoFormService.handleLoad(this.props.courseId, this.props.onSuccess);
  }

  render() {
    return (
      <CanDoForm
        onSubmit={this.canDoFormService.handleSubmit}
        onChange={this.canDoFormService.form.setValue}
        onReset={this.canDoFormService.form.reset}
        values={this.canDoFormService.form.getValues()}
        errors={this.canDoFormService.form.errors}
        submitting={this.canDoFormService.submit.fetching}
        error={this.canDoFormService.submit.error}
        isDirty={this.canDoFormService.form.isDirty}
      />
    );
  }
}

export default observer(CanDoFormContainer);
